module.exports = __webpack_public_path__ + "img/wav.04e9cdf6.svg";